import {gql, useLazyQuery} from '@apollo/client'
import {useSelector} from 'react-redux'
import {useLocation} from 'wouter'

export const GET_OPPORTUNITIES_REF_DATA = gql`
  query GetOpportunitiesRefData($filters: [String!], $azureRole: String) {
    filterValues(fields: $filters, azureRole: $azureRole) {
      filter
      values
      valuesInt
      valuesWithId {
        id
        name
      }
    }
  }
`

export default function useOpportunitiesRefData() {
  const timelineFilters = ['engagement_history', 'personal_history', 'wealth_history']
  const filters = [
    'interest_tag',
    'likelihood_to_give',
    'degree',
    'current_industry',
    'prospect_type',
    'giving_capacity',
    'college',
    'class_year',
    'board_member',
    'city',
    'state'
  ]
  const [location] = useLocation()
  const activeFilters = location.includes('/prospect-profile') ? timelineFilters : filters
  const azureRole = useSelector((state) => state.superUserTenantSlice.azureRole)
  const [getOpportunitiesRefData, {data: refData, loading: isRefDataLoading, error: refDataError, refetch}] =
    useLazyQuery(GET_OPPORTUNITIES_REF_DATA, {
      variables: {filters: activeFilters, ...(azureRole ? {azureRole} : {})},
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'network-only',
      errorPolicy: 'all'
    })
  return [getOpportunitiesRefData, {refData, isRefDataLoading, refDataError, refetch}]
}
